const callbacks = [];
const source    = 'https://www.sa88trk.com/scripts/sdk/everflow.js';
const script    = document.createElement('script');

let loaded = false;

script.src = source;
script.async = true;

script.addEventListener( 'load', () => {
  console.log('Everflow Loaded');
  callbacks.forEach( fn => fn( window.EF ) );
  callbacks.length = 0;
  loaded = true;
});

document.body.appendChild( script );

window.starry_everflow = {
  ready( fn ) {
    if ( !loaded ) {
      return callbacks.push( fn );
    }
    return fn( window.EF );
  }
};
